import { graphql } from 'gatsby';
import { isUserAgentMobile } from '../../../../netlify/edge-functions/lib/shared-functions';
import { lazy, startTransition, Suspense, useEffect, useState } from 'react';

const MultiStepEditionsContactForm = lazy(
  () => import('./components/MultiStep/MultiStepEditionsContactForm')
);

const SingleStepEditionsContactForm = lazy(
  () => import('./components/SingleStepForm/SingleStepForm')
);

const SimplifiedMobileForm = lazy(
  () => import('./components/SimplifiedMobileForm/SimplifiedMobileForm')
);

const EditionsContactForm = (props: Queries.EDITIONS_CONTACT_FORMFragment) => {
  const isMultiStep =
    props.editionsContactFormElements.options?.value?.includes('enable_multi_step') ?? false;

  const isMobileEnabled =
    props.editionsContactFormElements.options?.value?.includes('simplified_mobile_form') ?? false;

  const [isMobile, setIsMobile] = useState(false);

  const shouldRenderMobileForm = isMobileEnabled && isMobile;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      startTransition(() => {
        setIsMobile(isUserAgentMobile(window.navigator.userAgent));
      });
    }
  }, []);

  let FormComponent;
  if (shouldRenderMobileForm) {
    FormComponent = <SimplifiedMobileForm {...props} />;
  } else if (isMultiStep) {
    FormComponent = <MultiStepEditionsContactForm {...props} />;
  } else {
    FormComponent = <SingleStepEditionsContactForm {...props} />;
  }

  return <Suspense>{FormComponent}</Suspense>;
};

export const fragment = graphql`
  fragment EDITIONS_CONTACT_FORM on kontent_item_editions_contact_form {
    __typename
    system {
      codename
    }
    editionsContactFormElements: elements {
      campaign_id {
        value
      }
      legal_text {
        value
        links {
          link_id
          codename
        }
      }
      edition {
        value
      }
      form_submit_title {
        value
      }
      metadata_sub_method {
        value
      }
      success_redirect_page {
        value {
          system {
            codename
          }
        }
      }
      options {
        value
      }
      i18n_first_name {
        value
      }
      i18n_last_name {
        value
      }
      i18n_company_name {
        value
      }
      i18n_work_email {
        value
      }
      i18n_phone_number {
        value
      }
      i18n_country {
        value
      }
      i18n_select_country {
        value
      }
      i18n_referral_code {
        value
      }
      i18n_select_developers {
        value
      }
      i18n_i_already_use_sonarqube_ce {
        value
      }
      back_button_text {
        value
      }
      next_button_text {
        value
      }
      multi_step_headline {
        value
      }
    }
    system {
      codename
      id
      type
    }
  }
`;

export default EditionsContactForm;
